import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'

const mapStateToProps = state => ({
    locale: state.intl.locale,
    messages: state.intl.messages[state.intl.locale]
})

export default connect(mapStateToProps)(IntlProvider)


// WEBPACK FOOTER //
// ./src/containers/IntlProvider/index.js